import CSAT from "./KrCsat.vue";
import { install } from "@kurundata-ui-questionnaire/utils/install";

const KrCsat = install(CSAT); // 生成带有 install 方法的组件

export default KrCsat;
